import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { signOutUser } from './firebase';

const HeaderMenu = () => {
  return (
    <Navbar expand="lg" variant="dark" style={{ backgroundColor: '#ef2b70', borderRadius: '50px' }} className='p-3 m-3 shadow-md'>
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Navbar.Brand href="/" style={{ color: '#fff' }}>
          <img src="https://files.designbanner.co/banner-design-ai-logo-white-4.png" alt="Artwand Logo" className='ms-2' style={{ maxHeight: '30px' }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ borderColor: '#fff' }} className="ms-auto" />
      </div>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto" style={{ whiteSpace: 'nowrap' }}>
          <Nav.Link href="#" onClick={signOutUser} style={{ color: '#fff' }}>Logout</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default HeaderMenu;